// extracted by mini-css-extract-plugin
export default {"container":"ConsistencyRatio_container__s2B5G","label":"ConsistencyRatio_label__449Od","danger":"ConsistencyRatio_danger__QSty9","value":"ConsistencyRatio_value__Nktrq"};